'use client'

import { Mail, MapPin, Phone, Sparkles } from "lucide-react"
import { resolveColorHex, getVendorPrimaryColor } from "@/utils/util"
import { getVendorPhones } from "@/utils/vendorPhones"

export default function SubHeader({ fontClass, vendor }: { fontClass?: string, backgroundColorClass?: string, backgroundColorStyle?: React.CSSProperties, vendor?: any }) {
  const primary = resolveColorHex(getVendorPrimaryColor(vendor))
  const banner = vendor?.headBanner
  const phones = getVendorPhones(vendor)
  const showSecondary = phones.length > 0 || vendor?.email || vendor?.address

  if (!banner && !showSecondary) return null

  return (
    <div
      className={`text-[12px] text-white ${fontClass || ''}`}
      data-lpignore
      style={{ background: primary }}
    >
      <div className="mx-auto w-full max-w-[1280px] px-4 lg:px-8 min-h-9 py-1.5 md:py-0 flex items-center justify-center md:justify-between gap-4">
        <div className="flex items-center gap-5 min-w-0 justify-center md:justify-start">
          {banner && (
            <span className="inline-flex items-center gap-1.5 font-medium min-w-0 text-center md:text-left">
              <Sparkles className="h-3.5 w-3.5 shrink-0" />
              <span>{banner}</span>
            </span>
          )}
          {vendor?.address && (
            <span className="hidden xl:inline-flex items-center gap-1.5 opacity-85 min-w-0">
              <MapPin className="h-3.5 w-3.5 shrink-0" />
              <span className="truncate">{vendor.address}</span>
            </span>
          )}
        </div>
        <div className="hidden md:flex items-center gap-4 opacity-90 shrink-0">
          {phones.length > 0 && (
            <span className="inline-flex items-center gap-1.5">
              <Phone className="h-3.5 w-3.5" />
              <span>
                {phones.map((p, i) => (
                  <span key={p}>{i > 0 && ', '}<a href={`tel:${p}`} className="hover:opacity-100 transition-opacity">{p}</a></span>
                ))}
              </span>
            </span>
          )}
          {vendor?.email && (
            <a href={`mailto:${vendor.email}`} className="inline-flex items-center gap-1.5 hover:opacity-100 transition-opacity max-w-70 min-w-0">
              <Mail className="h-3.5 w-3.5 shrink-0" />
              <span className="truncate">{vendor.email}</span>
            </a>
          )}
        </div>
      </div>
    </div>
  )
}